module.exports = __webpack_public_path__ + "static/media/capa-contatos.5ec4d3bc.jpg";